import React from 'react';

/**
 * Individual farm card showing the last test run status.
 */
export default function FarmCard({ farm, lastRun, onSelect }) {
  const getStatusClass = (status) => {
    if (!status) return 'unknown';
    const s = status.toLowerCase();
    if (s === 'completed') return 'success';
    if (s === 'failed') return 'failure';
    if (s === 'running') return 'running';
    if (s === 'timeout') return 'warning';
    return 'unknown';
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    try {
      return new Date(dateStr).toLocaleString();
    } catch {
      return dateStr;
    }
  };

  const getStatusLabel = (status) => {
    if (!status) return 'Never run';
    return status.charAt(0).toUpperCase() + status.slice(1);
  };

  const statusClass = lastRun ? getStatusClass(lastRun.Status) : 'unknown';
  const statusLabel = lastRun ? getStatusLabel(lastRun.Status) : 'Never run';

  return (
    <div className="farm-card" onClick={onSelect}>
      <div className="farm-card-header">
        <h3>{farm.code}</h3>
        <div className={`status-badge ${statusClass}`}>
          {statusLabel}
        </div>
      </div>
      
      <div className="farm-card-body">
        {lastRun ? (
          <>
            <div className="farm-card-row">
              <span className="label">Last Run:</span>
              <span className="value">{formatDate(lastRun.StartedAt)}</span>
            </div>

            <div className="farm-card-row">
              <span className="label">Completed:</span>
              <span className="value">{formatDate(lastRun.CompletedAt)}</span>
            </div>

            <div className="farm-card-row">
              <span className="label">Triggered by:</span>
              <span className="value">{lastRun.TriggeredBy || '—'}</span>
            </div>
            
            {lastRun.Result && lastRun.Result.testResults && (
              <div className="farm-card-results">
                <div className={`test-summary ${lastRun.Result.testResults.success ? 'success' : 'failure'}`}>
                  <strong>{lastRun.Result.testResults.passed}</strong> of{' '}
                  <strong>{lastRun.Result.testResults.total}</strong> tests passed
                  {lastRun.Result.testResults.failures > 0 && (
                    <>, <strong>{lastRun.Result.testResults.failures}</strong> failures</>
                  )}
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="farm-card-empty">
            <p>No test runs yet</p>
          </div>
        )}
      </div>
      
      <div className="farm-card-footer">
        <span className="link">View details →</span>
      </div>
    </div>
  );
}
